<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

	<template v-if="item.game.time_min">{{ item.game.time_min }}</template>

	<template v-if="item.game.time_min !== item.game.time_max && item.game.time_min && item.game.time_max"> - {{ item.game.time_max }}</template>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky']

}

</script>

<style scoped>

</style>